import React, { useContext, useEffect, useRef, useState } from "react";
import "./styles.css";
import "../styles.css";
import { CSHeader, RippleButton } from "../../../Components/Atoms";
import { AddContactIcon, BloodDropIcon, CallIcon, ChevronRightIcon, CsBikeIcon, CsDashboardIcon, CsDeleteIcon, NewBannerIcon, PenIcon, showPwdIcon as ShowPwdIcon } from "../../../Assets/images/svgs";
import { useNavigate, useSearchParams } from "react-router-dom";
import PATHS from "../../../Routes/paths";
import { Spinner, useToast } from "@chakra-ui/react";
import { BLOOD_GROUP_TYPES, FUEL_TYPES, VEH_TYPE_NAMES } from "../../../Library/constants";
import CsModal from "../CsModal";
import { getLocalisedDate } from "../../../Library/datetime";
import { getStickersByVid, getVehiclesWithSticker, updateUserProfile } from "../../../APIs";
import { logFirebaseEvent } from "../../../firebase/logEventHelper";

const ProfilePage = () => {
  const navigate = useNavigate();
  const Toast = useToast();

  const [ userConfig, setUserConfig ] = useState({});
  const [ showDelModal, setShowDelModal ] = useState({});
  const [ selectedVehicle, setSelectedVehicle ] = useState({});
  const [ showVehDropdown, setShowVehDropdown ] = useState(false);
  const [ showStickersList, setShowStickersList ] = useState(false);
  const [ userVehicles, setUserVehicles ] = useState([]);
  const [ showLoader, setShowLoader ] = useState(false);

  const fetchStickersByVehicle = (veh) => {
    getStickersByVid(veh.idx, (err, data) => {
      if (err) {
        console.log(err);
        navigate(`/${PATHS.CONTACT_STICKER}${PATHS.LANDING_PAGE}`);
      } else {
        if (!data || !data.stickers) return navigate(`/${PATHS.CONTACT_STICKER}${PATHS.LANDING_PAGE}`);
        let config = { ...data.profile, stickerSettings: data.stickers[0], stickerCount: data.stickers.length, stickers: data.stickers };
        setUserConfig(config);
        setSelectedVehicle(veh);
      }
    });
  }

  useEffect(() => {
    document.body.classList.remove("Ev-Light-Theme-Container");

    let userVehicles = []
    let selVid = null;
    if (window.data) {
      if (window.data.vehicles && window.data.vehicles.length && window.data.vid) {
        userVehicles = window.data.vehicles;
        selVid = window.data.vid;
      } else {
        navigate(`/${PATHS.CONTACT_STICKER}${PATHS.LANDING_PAGE}`);
      }
    }

    if (!userVehicles || !userVehicles.length) return navigate(`/${PATHS.CONTACT_STICKER}${PATHS.LANDING_PAGE}`);

    getVehiclesWithSticker((err, vehicles) => {
      if (err) {
        navigate(`/${PATHS.CONTACT_STICKER}${PATHS.LANDING_PAGE}`);
      } else {
        if (vehicles && vehicles.length) {
          let filteredVehicles = userVehicles.filter(veh => vehicles.includes(veh.idx));
          if (filteredVehicles && filteredVehicles.length) {
            setUserVehicles(filteredVehicles);
            let selVeh = selVid;
            if (!vehicles.includes(selVid)) selVeh = filteredVehicles[0].idx;
            let selVehObj = filteredVehicles.find(veh => veh.idx === selVeh);
            fetchStickersByVehicle(selVehObj);
          }
        } else navigate(`/${PATHS.CONTACT_STICKER}${PATHS.LANDING_PAGE}`);
      }
    });
  }, []);

  const handleDelModal = (contact) => {
    setShowDelModal(contact);
  }

  const handleContactDelete = (contact) => {
    if (!userConfig.stickerSettings || !userConfig.stickerSettings.contId) return Toast({ isClosable: true, description: "Contact id not available", position: "bottom", variant: "subtle", duration: 3000 });
    setShowLoader(true);

    let updatedContacts = [];
    if (userConfig.emgCts.length > 1) {
      updatedContacts = userConfig.emgCts.filter(emgct => emgct.idx !== contact.idx);
    }

    updateUserProfile({ contId: userConfig.stickerSettings.contId, emgCts: updatedContacts }, [])
      .then(() => setUserConfig({ ...userConfig, emgCts: updatedContacts }))
      .catch(() => Toast({ isClosable: true, description: "Unable to delete emergency contact. Please try again later", position: "bottom", variant: "subtle", duration: 3000 }))
      .finally(() => setShowLoader(false));


    setShowDelModal({});
  }

  const getStickersList = (stickers) => {
    return (
      <div className="sticker-list-container">
        <div className="sticker-list-row heading">
          <p>Sticker Name</p>
          <p>Mapping Date</p>
        </div>
        {stickers.map(sticker => (
          <div key={sticker.nm} className="sticker-list-row">
            <p className="sticker-name">{sticker.nm}</p>
            <p className="sticker-date">{getLocalisedDate(sticker.dm, true)}</p>
          </div>
        ))}
      </div>
    )
  }

  const handleEdit = (addNewEc = false, editEc = false, selEc) => {
    logFirebaseEvent("EDIT_CS_PROFILE_DETAILS");
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify({ action: "edit-cs-profile", data: { selectedVehicle, addNewEc, editEc, selEc }}));
  }

  const handleVehicleChange = (vehicle) => {
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify({ action: "vehicle-selected", data: { vid: vehicle.idx } }));
    fetchStickersByVehicle(vehicle);
    setShowVehDropdown(false);
  }

  const handleBackPress = () => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "go-back" }));
  }

  const navigateInApp = () => {
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify({ action: "activate-sticker" }));
  }

  return (
    <div className="cs-profile-page">
      {showLoader ? <div className="profile-page-loader-overlay">
        <Spinner className="profile-page-loader" />
      </div> : null}
      <CSHeader headerText="Contact Sticker" onClick={handleBackPress} />

      {userConfig && userConfig.fn ? <>
        <div className="user-vehicle-info-container">
          <RippleButton onClick={() => userVehicles.length > 1 ? setShowVehDropdown(!showVehDropdown) : {}} className="user-vehicle-info-box">
            <CsBikeIcon />
            {selectedVehicle.idx ? <div className="user-vehicle-info">
              <p className="user-vehicle-name cs-text-gradient">{`${selectedVehicle.vmk} ${selectedVehicle.mo || ""}`}</p>
              <p className="user-vehicle-dets">
                {selectedVehicle.reg ? <span>{(selectedVehicle.reg || "").replaceAll(" ", "")} </span> : ""}
                {selectedVehicle.ftyp ? <span>{`| ${FUEL_TYPES[selectedVehicle.ftyp]}`}</span> : ""}
                <span>{selectedVehicle.typ ? `| ${VEH_TYPE_NAMES[selectedVehicle.typ]}` : ""}</span>
              </p>
            </div> : null}

            {userVehicles.length > 1 ? <ChevronRightIcon className="cs-select-vehicle-icon" /> : null}
          </RippleButton>

          {userConfig.stickerCount ? <RippleButton onClick={() => setShowStickersList(true)} className="stickers-mapped-btn">
            <CsDashboardIcon className="stickers-mapped-icon" />
            {`${userConfig.stickerCount} Stickers Mapped`}
          </RippleButton> : null}

          <div className={`veh-dropdown-options-container ${showVehDropdown ? "expand" : ""}`}>
            { (userVehicles && userVehicles.length) ? userVehicles.map(vehicle => (
              <RippleButton onClick={() => userVehicles.length > 1 ? handleVehicleChange(vehicle) : {}} key={vehicle.idx} className="dropdown-vehicle-box">
                <CsBikeIcon />
                <div className="user-vehicle-info">
                  <p className={`user-vehicle-name ${vehicle.idx === selectedVehicle.idx ? "cs-text-gradient" : ""}`}>{`${vehicle.vmk} ${vehicle.mo || ""}`}</p>
                  <p className="user-vehicle-dets">
                    {vehicle.reg ?<span>{(vehicle.reg || "").replaceAll(" ", "")} | </span> : ""}
                    {vehicle.ftyp ? <span>{FUEL_TYPES[vehicle.ftyp]} | </span> : ""}
                    <span>{vehicle.typ ? VEH_TYPE_NAMES[vehicle.typ] : ""}</span>
                  </p>
                </div>
              </RippleButton>
            )) : null }
          </div>
        </div>

        <div className="user-info-container">
          <p className="user-info-title">Control what others see about you</p>

          <div className="user-details-box">
            <div className="user-image">
              {userConfig.imgUrl ? <img src={userConfig.imgUrl} alt="" /> : userConfig.fn[0]}
            </div>
            <div className="user-details">
              <p className="user-name cs-text-gradient">{userConfig.fn}</p>
              <p className="user-dets">
                <span className="user-mob">
                  <CallIcon />
                  {userConfig.mob}
                </span>
                {userConfig.bldGrp && userConfig.bldGrp > 0 ? <span className="user-blood-group">
                  | <BloodDropIcon className="blood-group-icon" />
                  Blood group : {BLOOD_GROUP_TYPES[userConfig.bldGrp]}
                </span> : null}
              </p>
            </div>

            <RippleButton onClick={() => handleEdit()} className="edit-icon-button info-box-position">
              <PenIcon />
            </RippleButton>
          </div>

          <div className="user-emergency-contacts-container">
            <p className="emergency-contacts-title">Emergency contacts</p>
            {userConfig.emgCts ? <>
              { userConfig.emgCts.map(contact => (
                <div key={contact.mob} className="emerygency-contact-box">
                  <div className="contact-details">
                    <p className="contact-name">{contact.nm}</p>
                    <p className="contact-mob">+91 {contact.mob}</p>
                  </div>

                  <div className="modify-contact-details">
                    <RippleButton onClick={() => handleEdit(false, true, contact)} className="edit-icon-button emergency-contact">
                      <PenIcon />
                    </RippleButton>
                    {(userConfig.emgCts && userConfig.emgCts.length > 1) ? <RippleButton onClick={() => handleDelModal(contact)}>
                      <CsDeleteIcon />
                    </RippleButton> : null}
                  </div>
                </div>
              )) }
              {userConfig.emgCts.length < 3 ? <RippleButton className="add-contact-button" onClick={() => handleEdit(true)}>
                <div className="call-icon-box">
                  <AddContactIcon />
                </div>
                Add contacts
              </RippleButton> : null}
            </> : null}
          </div>

          {userConfig.stickers && userConfig.stickers.length ? <p className="user-cs-scan-count">
            <span>{userConfig.stickers.reduce((sum, val) => sum + (val.scanCount || 0), 0)} People</span> scanned your contact sticker
          </p> : null}

          {/* stickers=${userConfig.stickers.map(sticker => sticker.uniqueCode)}&vid=${selectedVehicle} */}
          <RippleButton className="stretched-section-button" onClick={() => navigate(`/${PATHS.CONTACT_STICKER}${PATHS.CS_NOTIFICATIONS}`, { state: { stickers: userConfig.stickers, vid: selectedVehicle.idx, fromProfilePage: true } })}>
            <p>Notifications & alerts</p>
            <span><ChevronRightIcon /></span>
          </RippleButton>

          <div className="profile-options-container">
            <RippleButton onClick={() => navigate(`/${PATHS.CONTACT_STICKER}${PATHS.STICKER_SETTINGS}?vid=${selectedVehicle.idx}`, { state: { stickers: userConfig.stickers } })} className="profile-options-button">
              <div className="details-and-arrow-seperator">
                <CsDashboardIcon />
                <div className="option-details">
                  <p className="option-title">Sticker settings</p>
                  <p className="option-description">Control what others can see when they scan QR code on the sticker</p>
                </div>
              </div>
              <ChevronRightIcon className="options-arrow-icon" />
            </RippleButton>

            <div className="profile-options-seperator"></div>

            <RippleButton className="profile-options-button" onClick={() => navigate(`${PATHS.SCANNED_PREVIEW_PAGE}?preview=true&uc=${userConfig.stickers[0].uniqueCode}`, { state: { vid: selectedVehicle.idx } })}>
              <div className="details-and-arrow-seperator">
                <ShowPwdIcon />
                <div className="option-details">
                  <p className="option-title">Preview contact page</p>
                  <p className="option-description">Have a look at the page others will see when they will scan the QR</p>
                </div>
              </div>
              <ChevronRightIcon className="options-arrow-icon" />
            </RippleButton>

            <div className="profile-options-seperator"></div>

            <RippleButton className="profile-options-button" onClick={navigateInApp}>
              <div className="details-and-arrow-seperator">
                <NewBannerIcon />
                <div className="option-details">
                  <p className="option-title">Activate new sticker</p>
                  <p className="option-description">Bought a new contact sticker? Activate it from here</p>
                </div>
              </div>
              <ChevronRightIcon className="options-arrow-icon" />
            </RippleButton>
          </div>
        </div>
      </> : <Spinner className="centralized-loader" />}

      <CsModal
        openModal={!!showDelModal.idx}
        closeModal={() => setShowDelModal({})}
        headerText={"Deleting emergency contact"}
        bodyContent={"Are you sure you want to delete this emergency contact"}
        confirmBtn={"Delete"}
        onConfirm={() => handleContactDelete(showDelModal)}
        cancelBtn={"Cancel"}
      />
      {userConfig.stickers ? <CsModal
        openModal={showStickersList}
        closeModal={() => setShowStickersList(false)}
        headerText={`${userConfig.stickerCount} Stickers Mapped`}
        bodyContent={getStickersList(userConfig.stickers)}
        cancelBtn={"Close"}
      /> : null}

      <div onClick={() => setShowVehDropdown(false)} className={`veh-dropdown-overlay ${showVehDropdown ? "visible" : ""}`}></div>
    </div>
  )
}

export default ProfilePage
